import "./App.css";
import { useEffect, useState } from "react";

function App() {
  const fullText = "三人行视觉设计";
  const [typed, setTyped] = useState("");

  useEffect(() => {
    let i = 0;
    const speed = 100; // 打字速度(毫秒)，越小越快
    const timer = setInterval(() => {
      i += 1;
      setTyped(fullText.slice(0, i));
      if (i >= fullText.length) {
        clearInterval(timer);
      }
    }, speed);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="App">
      <div className="main-content">
        <div className="logo-container">
          <img src="logo.jpg" className="logo" alt="三人行视觉设计" />
        </div>
        <div className="text-content">
          <h1 className="typewriter">
            <span className="typewriter-text">{typed}</span>
            <span className="cursor" aria-hidden="true"></span>
          </h1>
        </div>
      </div>
      <footer className="footer">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          className="icp-link"
        >
          沪ICP备2025138088号-1
        </a>
      </footer>
    </div>
  );
}

export default App;
